import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { LabelSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  percentage: number;
};

export function BatteryPercentage({ percentage }: Readonly<Props>) {
  const { theme } = useStyles();

  return (
    <FlexRow
      gap={theme.sizing.scale0}
      centered
    >
      {!percentage && (
        <>
          <MaterialIcon name="battery_0_bar" />
          <LabelSmall>0%</LabelSmall>
        </>
      )}
      {!!percentage && (
        <>
          {percentage < 33 && <MaterialIcon name="battery_2_bar" />}
          {percentage >= 33 && percentage < 66 && <MaterialIcon name="battery_3_bar" />}
          {percentage >= 66 && <MaterialIcon name="battery_full" />}
          <LabelSmall>{percentage}%</LabelSmall>
        </>
      )}
    </FlexRow>
  );
}
